export enum LogType {
  INTERACTION_LOG = 'INTERACTION_LOG',
  FLOW_LOG = 'FLOW_LOG',
  TOOL_CITATIONS_LOG = 'TOOL_CITATIONS_LOG'
}
